import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import { ALLOCATOR_MODAL_LEFT_BUTTON, ALLOCATOR_MODAL_RIGHT_BUTTON, ALLOCATOR_MODAL_INPUT } from '../utils/testing/TestIDs';
import { StyledTextInput, TargetAllocatorContainer, GrayCircleIconButton } from './styled-components';
export var AllocatorInput = function AllocatorInput(_ref) {
  var _AcornsIcon$Icon, _AcornsIcon$Icon2;

  var amount = _ref.amount,
      isOverMaxNumber = _ref.isOverMaxNumber,
      isZero = _ref.isZero,
      isLeftButtonDisabled = _ref.isLeftButtonDisabled,
      isRightButtonDisabled = _ref.isRightButtonDisabled,
      onLeftButtonPress = _ref.onLeftButtonPress,
      onRightButtonPress = _ref.onRightButtonPress,
      onInputChange = _ref.onInputChange,
      onInputFocus = _ref.onInputFocus,
      onInputBlur = _ref.onInputBlur,
      className = _ref.className,
      _ref$inputTestId = _ref.inputTestId,
      inputTestId = _ref$inputTestId === void 0 ? ALLOCATOR_MODAL_INPUT : _ref$inputTestId,
      _ref$leftButtonTestId = _ref.leftButtonTestId,
      leftButtonTestId = _ref$leftButtonTestId === void 0 ? ALLOCATOR_MODAL_LEFT_BUTTON : _ref$leftButtonTestId,
      _ref$rightButtonTestI = _ref.rightButtonTestId,
      rightButtonTestId = _ref$rightButtonTestI === void 0 ? ALLOCATOR_MODAL_RIGHT_BUTTON : _ref$rightButtonTestI;
  return /*#__PURE__*/React.createElement(TargetAllocatorContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(GrayCircleIconButton, {
    onClick: onLeftButtonPress,
    disabled: isLeftButtonDisabled,
    "data-testid": leftButtonTestId
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: (_AcornsIcon$Icon = AcornsIcon.Icon) === null || _AcornsIcon$Icon === void 0 ? void 0 : _AcornsIcon$Icon.InlineMinus,
    width: 12,
    height: 12
  })), /*#__PURE__*/React.createElement(StyledTextInput, {
    label: {
      hidden: true,
      value: 'Hidden Label'
    },
    isOverMaxNumber: isOverMaxNumber,
    isZero: isZero,
    inputProps: {
      name: 'hiddenLabel',
      value: amount,
      maxLength: 2,
      onChange: onInputChange,
      onFocus: onInputFocus,
      onBlur: onInputBlur,
      'data-testid': inputTestId
    }
  }), /*#__PURE__*/React.createElement(GrayCircleIconButton, {
    onClick: onRightButtonPress,
    disabled: isRightButtonDisabled,
    "data-testid": rightButtonTestId
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: (_AcornsIcon$Icon2 = AcornsIcon.Icon) === null || _AcornsIcon$Icon2 === void 0 ? void 0 : _AcornsIcon$Icon2.InlinePlus,
    width: 12,
    height: 12
  })));
};